import { red } from '@material-ui/core/colors';
import { createTheme } from '@material-ui/core/styles';

export const Theme = createTheme({
  palette: {
    primary: {
      main: '#17d1b5',
    },
    secondary: {
      main: '#556cd6',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
  },
});
